/** @format */

// 年収をNumber型に変換

export const toAnnualBusiness = (value: string | number | null) => {
  if (value === null || value === undefined) return value;
  if (value === "") return null;
  return Number(value);
};
